"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOGS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_CATALOGS = (0, gql_1.gql)(`
  query catalogs(
    $projectId: ID!,
    $sort: [CatalogOrderBy!]
    $first: Int,
  ) {
    projects(ids: [$projectId]) {
      edges {
        node {
          id
          catalogs(first: $first, sort: $sort) {
            edges {
              node {
                id
                title
                createdAt
              }
            }
          }
        }
      }
    }
  }
`);
